import React from 'react';
import Styles from './PlayerInsightButton.module.scss';

const Button = (props) => {
  return (
    <div>
      <button
        className={Styles.btn}
        type='button'
        onClick={props.onClick ? () => props.onClick() : null}
        disabled={props.disabled ?? false}
      >
        {props.label}
      </button>
    </div>
  );
};

export default Button;
